const translations = {
  uk: {
    header: {
      tagline: 'Спеціалізуємось на створенні інтерфейсів, сайтів і застосунків.',
    },
    hero: {
      headline1: 'Цифрові рішення для',
      headline2: 'сучасної торгівлі',
      subheadline:
        'Ми розробляємо прості, зрозумілі та ефективні програмні рішення. Від створення сайтів до мобільних застосунків і просування.',
      cta_start: 'Розпочати проект',
      cta_services: 'Наші послуги',
    },
    services: {
      heading: 'Наша експертиза',
      subheading:
        'Ми зосереджені на трьох ключових напрямках, щоб допомогти вашому бізнесу розвиватися в цифровому просторі.',
      items: [
        {
          title: 'Створення та дизайн сайтів',
          description:
            'Унікальні адаптивні сайти, орієнтовані на конверсію. Ми будуємо чіткі інтерфейси, які сподобаються вашим клієнтам.',
        },
        {
          title: 'Цифрове просування',
          description:
            'Стратегічна оптимізація для пошукових систем (SEO) та маркетинг у соціальних мережах для зростання впізнаваності вашого бренду.',
        },
        {
          title: 'Розробка мобільних застосунків',
          description:
            'Нативні та кросплатформні мобільні застосунки, спеціально розроблені для роздрібних підприємств, щоб підвищити лояльність клієнтів.',
        },
      ],
    },
    contact: {
      heading: 'Розпочати проект',
      subheading:
        "Коротко розкажіть про цілі вашого проекту, і ми зв'яжемось із наступними кроками.",
      name_label: "Повне ім'я",
      name_placeholder: 'Іван Іваненко',
      email_label: 'Електронна пошта',
      email_placeholder: 'you@example.com',
      message_label: 'Повідомлення',
      message_placeholder:
        'Опишіть обсяг проекту, терміни, приблизний бюджет.',
      send_btn: 'Надіслати запит',
      copy_btn: 'Копіювати текст листа',
      copied: 'Скопійовано!',
      preview_label: 'Згенерований текст листа',
      chars_hint: 'символів',
      mail_if_not_open: 'Якщо поштовий клієнт не відкрився, скопіюйте і надішліть вручну.',
      min_error: (min) => `Мінімальна довжина повідомлення ${min} символів.`,
      max_error: (max) => `Максимальна довжина повідомлення ${max} символів.`,
      email_subject: (name) => `Запит щодо проекту від ${name}`,
      email_body_title: 'Запит на контакт',
      email_body_sep: '---------------',
      email_name: 'Ім\'я',
      email_message: 'Повідомлення',
    },
    footer: {
      tagline:
        'Створюємо прості, ефективні цифрові рішення для роздрібних підприємств по всьому світу.',
      contact: 'Контакти',
      links: 'Посилання',
      link_services: 'Послуги',
      link_about: 'Про нас',
      link_contact: 'Контакти',
      link_privacy: 'Політика конфіденційності',
      rights: 'Всі права захищено.',
    },
    privacy: {
      badge: 'Політика конфіденційності',
      title: 'Політика конфіденційності',
      updated: 'Останнє оновлення: 19 листопада 2025',
      intro:
        'Компанія <strong>shopprograms.com</strong> («ми», «нас», «наш») поважає вашу конфіденційність і зобов\'язується її захищати відповідно до цієї політики. Ця Політика конфіденційності пояснює, яку інформацію ми збираємо, як ми її використовуємо та які у вас є варіанти.',
      collect_title: 'Яку інформацію ми збираємо',
      collect_items: [
        '<strong>Контактна інформація</strong> (наприклад, ім\'я, електронна пошта, телефон) — коли ви звертаєтеся до нас.',
        '<strong>Дані про використання</strong>: переглянуті сторінки, натиснуті посилання та загальна інформація про пристрій, зібрана за допомогою файлів cookie/аналітики.',
        '<strong>Повідомлення</strong>, які ви надсилаєте нам (запити на підтримку, деталі проекту).',
      ],
      use_title: 'Як ми використовуємо інформацію',
      use_items: [
        'Надання та вдосконалення послуг і загального досвіду.',
        'Відповідь на запити та запити про підтримку.',
        'Аналіз ефективності та запобігання зловживанням.',
        'Виконання юридичних зобов\'язань.',
      ],
      cookies_title: 'Файли cookie та аналітика',
      cookies_text:
        'Ми можемо використовувати файли cookie та подібні технології для роботи та вдосконалення сайту. Ви можете керувати файлами cookie в налаштуваннях браузера. Блокування деяких файлів cookie може вплинути на функціональність.',
      cookie_policy_title: 'Політика файлів cookie',
      cookie_policy_items: [
        '<strong>Строго необхідні</strong>: безпека, балансування навантаження.',
        '<strong>Налаштування</strong>: збереження параметрів.',
        '<strong>Аналітика</strong>: розуміння використання.',
        '<strong>Маркетинг</strong>: вимірювання кампаній (якщо використовується).',
      ],
      cookie_policy_text:
        'Ви можете видаляти або блокувати файли cookie; деякі функції можуть погіршитися при відключенні.',
      legal_title: 'Правові підстави (ЄЕЗ/Великобританія)',
      legal_items: [
        '<strong>Договір</strong>',
        '<strong>Законні інтереси</strong>',
        '<strong>Згода</strong>',
        '<strong>Юридичне зобов\'язання</strong>',
      ],
      sharing_title: 'Передача та зберігання даних',
      sharing_text:
        'Ми не продаємо персональні дані. Дані зберігаються лише стільки, скільки необхідно, а потім видаляються або анонімізуються.',
      security_title: 'Безпека',
      security_text:
        'Ми використовуємо розумні технічні та організаційні заходи; жоден метод не є 100% безпечним.',
      rights_title: 'Ваші права',
      rights_text:
        'Залежно від місцезнаходження ви можете отримувати доступ, виправляти, видаляти, обмежувати, заперечувати або запитувати перенесення даних. Використовуйте форму нижче.',
      dsar_title: 'Форма запиту щодо даних (DSAR)',
      req_type_label: 'Тип запиту',
      req_types: [
        { value: 'Access', label: 'Доступ (копія даних)' },
        { value: 'Deletion', label: 'Видалення' },
        { value: 'Correction', label: 'Виправлення' },
        { value: 'Portability', label: 'Перенесення' },
        { value: 'Opt-out', label: 'Відмова від маркетингу' },
      ],
      name_label: "Повне ім'я",
      email_label: 'Електронна пошта',
      region_label: 'Країна / Регіон (необов\'язково)',
      details_label: 'Деталі',
      details_placeholder: 'Опишіть ваш запит та будь-які відповідні ідентифікатори.',
      confirm_text: 'Я розумію, що може знадобитися перевірка особи.',
      submit_btn: 'Надіслати запит',
      copy_btn: 'Копіювати текст листа',
      copied: 'Скопійовано!',
      preview_label: 'Згенерований текст листа',
      preview_note: 'Надішліть згенерований лист, якщо клієнт не відкрився автоматично.',
      transfers_title: 'Міжнародна передача даних',
      transfers_text:
        'Дані можуть оброблятися в інших країнах із застосуванням відповідних гарантій.',
      children_title: 'Конфіденційність дітей',
      children_text:
        'Ресурс не призначений для дітей до 13 років; ми свідомо не збираємо такі дані.',
      changes_title: 'Зміни',
      changes_text: 'Ми можемо оновлювати політику; зміни будуть відображені тут.',
      contact_title: 'Зв\'яжіться з нами',
      back_home: '← На головну',
      dsar_email_type: 'Тип',
      dsar_email_name: 'Ім\'я',
      dsar_email_region: 'Регіон',
      dsar_email_details: 'Деталі',
      dsar_email_title: 'Запит суб\'єкта даних',
      dsar_email_sep: '---------------------',
    },
  },

  en: {
    header: {
      tagline: 'Specialize in creating interfaces, websites & apps.',
    },
    hero: {
      headline1: 'Digital solutions for',
      headline2: 'modern retail',
      subheadline:
        'We design simple, clear, and effective software solutions. From website creation to mobile apps and promotion.',
      cta_start: 'Start a Project',
      cta_services: 'Our Services',
    },
    services: {
      heading: 'Our Expertise',
      subheading:
        'We focus on three core areas to help your business thrive in the digital space.',
      items: [
        {
          title: 'Website Creation & Design',
          description:
            'Custom, responsive websites designed to convert. We build clean interfaces that your customers will love to use.',
        },
        {
          title: 'Digital Promotion',
          description:
            'Strategic search engine optimization (SEO) and social media marketing to grow your brand\'s visibility and reach.',
        },
        {
          title: 'Mobile App Development',
          description:
            'Native and cross-platform mobile applications specifically tailored for retail businesses to enhance customer loyalty.',
        },
      ],
    },
    contact: {
      heading: 'Start a Project',
      subheading:
        "Tell us briefly about your project goals, and we'll get back with next steps.",
      name_label: 'Full name',
      name_placeholder: 'John Doe',
      email_label: 'Email',
      email_placeholder: 'you@example.com',
      message_label: 'Message',
      message_placeholder: 'Describe the project scope, deadlines, budget rough idea.',
      send_btn: 'Send inquiry',
      copy_btn: 'Copy email text',
      copied: 'Copied!',
      preview_label: 'Generated email body',
      chars_hint: 'characters',
      mail_if_not_open: 'If your mail client did not open, copy and send manually.',
      min_error: (min) => `Minimum message length is ${min} characters.`,
      max_error: (max) => `Maximum message length is ${max} characters.`,
      email_subject: (name) => `Project inquiry from ${name}`,
      email_body_title: 'Contact Request',
      email_body_sep: '---------------',
      email_name: 'Name',
      email_message: 'Message',
    },
    footer: {
      tagline: 'Creating simple, effective digital solutions for retail businesses worldwide.',
      contact: 'Contact',
      links: 'Links',
      link_services: 'Services',
      link_about: 'About Us',
      link_contact: 'Contact',
      link_privacy: 'Privacy Policy',
      rights: 'All rights reserved.',
    },
    privacy: {
      badge: 'Privacy Policy',
      title: 'Privacy Policy',
      updated: 'Last updated: 19 November 2025',
      intro:
        'At <strong>shopprograms.com</strong> ("we", "us", "our"), we respect your privacy and are committed to protecting it by complying with this policy. This Privacy Policy explains what information we collect, how we use it, and your choices.',
      collect_title: 'Information We Collect',
      collect_items: [
        '<strong>Contact information</strong> (e.g., name, email, phone) when you contact us.',
        '<strong>Usage data</strong> such as pages viewed, links clicked, and general device info collected via cookies/analytics.',
        '<strong>Communications</strong> you send to us (support requests, project details).',
      ],
      use_title: 'How We Use Information',
      use_items: [
        'Provide and improve services and overall experience.',
        'Respond to inquiries and support requests.',
        'Analyze performance and prevent abuse.',
        'Comply with legal obligations.',
      ],
      cookies_title: 'Cookies & Analytics',
      cookies_text:
        'We may use cookies and similar technologies to operate and improve the website. You can control cookies in your browser settings. Blocking some cookies may impact functionality.',
      cookie_policy_title: 'Cookie Policy',
      cookie_policy_items: [
        '<strong>Strictly necessary</strong>: security, load balancing.',
        '<strong>Preferences</strong>: remembering choices.',
        '<strong>Analytics</strong>: understanding usage.',
        '<strong>Marketing</strong>: measuring campaigns (if used).',
      ],
      cookie_policy_text:
        'You can delete or block cookies; some features may degrade if disabled.',
      legal_title: 'Legal Bases (EEA/UK)',
      legal_items: [
        '<strong>Contract</strong>',
        '<strong>Legitimate interests</strong>',
        '<strong>Consent</strong>',
        '<strong>Legal obligation</strong>',
      ],
      sharing_title: 'Sharing & Retention',
      sharing_text:
        'We do not sell personal data. Data is retained only as long as needed and then deleted or anonymized.',
      security_title: 'Security',
      security_text:
        'We use reasonable technical and organizational measures; no method is 100% secure.',
      rights_title: 'Your Rights',
      rights_text:
        'Depending on location you may access, correct, delete, restrict, object, or request portability. Use the form below.',
      dsar_title: 'Data Request Form (DSAR)',
      req_type_label: 'Request type',
      req_types: [
        { value: 'Access', label: 'Access (copy of data)' },
        { value: 'Deletion', label: 'Deletion' },
        { value: 'Correction', label: 'Correction' },
        { value: 'Portability', label: 'Portability' },
        { value: 'Opt-out', label: 'Opt-out of marketing' },
      ],
      name_label: 'Full name',
      email_label: 'Email',
      region_label: 'Country / Region (optional)',
      details_label: 'Details',
      details_placeholder: 'Describe your request and any relevant identifiers.',
      confirm_text: 'I understand identity verification may be required.',
      submit_btn: 'Submit request',
      copy_btn: 'Copy email text',
      copied: 'Copied!',
      preview_label: 'Generated email body',
      preview_note: 'Send the generated email if your client did not open automatically.',
      transfers_title: 'International Transfers',
      transfers_text: 'Data may be processed in other countries with safeguards applied.',
      children_title: "Children's Privacy",
      children_text:
        'Not directed to children under 13; we do not knowingly collect such data.',
      changes_title: 'Changes',
      changes_text: 'We may update the policy; changes will appear here.',
      contact_title: 'Contact Us',
      back_home: '← Back to home',
      dsar_email_type: 'Type',
      dsar_email_name: 'Name',
      dsar_email_region: 'Region',
      dsar_email_details: 'Details',
      dsar_email_title: 'Data Subject Request',
      dsar_email_sep: '---------------------',
    },
  },

  de: {
    header: {
      tagline: 'Spezialisiert auf die Erstellung von Interfaces, Websites & Apps.',
    },
    hero: {
      headline1: 'Digitale Lösungen für',
      headline2: 'modernen Handel',
      subheadline:
        'Wir entwickeln einfache, klare und effektive Softwarelösungen. Von der Website-Erstellung bis zu mobilen Apps und Promotion.',
      cta_start: 'Projekt starten',
      cta_services: 'Unsere Leistungen',
    },
    services: {
      heading: 'Unsere Expertise',
      subheading:
        'Wir konzentrieren uns auf drei Kernbereiche, um Ihrem Unternehmen im digitalen Raum zum Erfolg zu verhelfen.',
      items: [
        {
          title: 'Website-Erstellung & Design',
          description:
            'Individuelle, responsive Websites, die konvertieren. Wir entwickeln klare Interfaces, die Ihre Kunden lieben werden.',
        },
        {
          title: 'Digitale Promotion',
          description:
            'Strategische Suchmaschinenoptimierung (SEO) und Social-Media-Marketing, um die Sichtbarkeit Ihrer Marke zu steigern.',
        },
        {
          title: 'Mobile App-Entwicklung',
          description:
            'Native und plattformübergreifende mobile Anwendungen, speziell für den Einzelhandel entwickelt, um die Kundentreue zu stärken.',
        },
      ],
    },
    contact: {
      heading: 'Projekt starten',
      subheading:
        'Erzählen Sie uns kurz von Ihren Projektzielen, und wir melden uns mit den nächsten Schritten.',
      name_label: 'Vollständiger Name',
      name_placeholder: 'Max Mustermann',
      email_label: 'E-Mail',
      email_placeholder: 'you@example.com',
      message_label: 'Nachricht',
      message_placeholder: 'Beschreiben Sie den Projektumfang, Fristen, ungefähres Budget.',
      send_btn: 'Anfrage senden',
      copy_btn: 'E-Mail-Text kopieren',
      copied: 'Kopiert!',
      preview_label: 'Generierter E-Mail-Text',
      chars_hint: 'Zeichen',
      mail_if_not_open: 'Falls Ihr Mail-Client nicht geöffnet wurde, kopieren und manuell senden.',
      min_error: (min) => `Mindestlänge der Nachricht: ${min} Zeichen.`,
      max_error: (max) => `Maximale Länge der Nachricht: ${max} Zeichen.`,
      email_subject: (name) => `Projektanfrage von ${name}`,
      email_body_title: 'Kontaktanfrage',
      email_body_sep: '---------------',
      email_name: 'Name',
      email_message: 'Nachricht',
    },
    footer: {
      tagline:
        'Wir entwickeln einfache, effektive digitale Lösungen für den Einzelhandel weltweit.',
      contact: 'Kontakt',
      links: 'Links',
      link_services: 'Leistungen',
      link_about: 'Über uns',
      link_contact: 'Kontakt',
      link_privacy: 'Datenschutzrichtlinie',
      rights: 'Alle Rechte vorbehalten.',
    },
    privacy: {
      badge: 'Datenschutzrichtlinie',
      title: 'Datenschutzrichtlinie',
      updated: 'Zuletzt aktualisiert: 19. November 2025',
      intro:
        'Bei <strong>shopprograms.com</strong> („wir", „uns", „unser") respektieren wir Ihre Privatsphäre und verpflichten uns, sie gemäß dieser Richtlinie zu schützen.',
      collect_title: 'Welche Informationen wir sammeln',
      collect_items: [
        '<strong>Kontaktinformationen</strong> (z. B. Name, E-Mail, Telefon) wenn Sie uns kontaktieren.',
        '<strong>Nutzungsdaten</strong> wie besuchte Seiten, geklickte Links und allgemeine Geräteinformationen über Cookies/Analytics.',
        '<strong>Kommunikation</strong>, die Sie uns senden (Support-Anfragen, Projektdetails).',
      ],
      use_title: 'Wie wir Informationen verwenden',
      use_items: [
        'Bereitstellung und Verbesserung von Diensten und der Gesamterfahrung.',
        'Beantwortung von Anfragen und Support-Anfragen.',
        'Leistungsanalyse und Missbrauchsprävention.',
        'Erfüllung gesetzlicher Verpflichtungen.',
      ],
      cookies_title: 'Cookies & Analytics',
      cookies_text:
        'Wir können Cookies und ähnliche Technologien verwenden. Sie können Cookies in Ihren Browser-Einstellungen steuern. Das Blockieren einiger Cookies kann die Funktionalität beeinträchtigen.',
      cookie_policy_title: 'Cookie-Richtlinie',
      cookie_policy_items: [
        '<strong>Unbedingt erforderlich</strong>: Sicherheit, Lastverteilung.',
        '<strong>Präferenzen</strong>: Einstellungen speichern.',
        '<strong>Analytics</strong>: Nutzung verstehen.',
        '<strong>Marketing</strong>: Kampagnen messen (falls verwendet).',
      ],
      cookie_policy_text:
        'Sie können Cookies löschen oder blockieren; einige Funktionen können beeinträchtigt werden.',
      legal_title: 'Rechtsgrundlagen (EWR/UK)',
      legal_items: [
        '<strong>Vertrag</strong>',
        '<strong>Berechtigte Interessen</strong>',
        '<strong>Einwilligung</strong>',
        '<strong>Rechtliche Verpflichtung</strong>',
      ],
      sharing_title: 'Weitergabe & Aufbewahrung',
      sharing_text:
        'Wir verkaufen keine personenbezogenen Daten. Daten werden nur so lange aufbewahrt, wie nötig, und dann gelöscht oder anonymisiert.',
      security_title: 'Sicherheit',
      security_text:
        'Wir setzen angemessene technische und organisatorische Maßnahmen ein; keine Methode ist 100 % sicher.',
      rights_title: 'Ihre Rechte',
      rights_text:
        'Je nach Standort können Sie Zugang, Berichtigung, Löschung, Einschränkung, Widerspruch oder Datenübertragbarkeit beantragen. Verwenden Sie das untenstehende Formular.',
      dsar_title: 'Datenschutzanfrage (DSAR)',
      req_type_label: 'Anfragetyp',
      req_types: [
        { value: 'Access', label: 'Zugang (Datenkopie)' },
        { value: 'Deletion', label: 'Löschung' },
        { value: 'Correction', label: 'Korrektur' },
        { value: 'Portability', label: 'Datenübertragbarkeit' },
        { value: 'Opt-out', label: 'Abmeldung vom Marketing' },
      ],
      name_label: 'Vollständiger Name',
      email_label: 'E-Mail',
      region_label: 'Land / Region (optional)',
      details_label: 'Details',
      details_placeholder: 'Beschreiben Sie Ihre Anfrage und relevante Identifikatoren.',
      confirm_text: 'Ich verstehe, dass eine Identitätsprüfung erforderlich sein kann.',
      submit_btn: 'Anfrage absenden',
      copy_btn: 'E-Mail-Text kopieren',
      copied: 'Kopiert!',
      preview_label: 'Generierter E-Mail-Text',
      preview_note: 'Senden Sie die generierte E-Mail, falls der Client nicht automatisch geöffnet wurde.',
      transfers_title: 'Internationale Übermittlungen',
      transfers_text: 'Daten können in anderen Ländern mit entsprechenden Schutzmaßnahmen verarbeitet werden.',
      children_title: 'Datenschutz für Kinder',
      children_text: 'Nicht für Kinder unter 13 Jahren bestimmt; wir sammeln solche Daten nicht wissentlich.',
      changes_title: 'Änderungen',
      changes_text: 'Wir können die Richtlinie aktualisieren; Änderungen erscheinen hier.',
      contact_title: 'Kontaktieren Sie uns',
      back_home: '← Zurück zur Startseite',
      dsar_email_type: 'Typ',
      dsar_email_name: 'Name',
      dsar_email_region: 'Region',
      dsar_email_details: 'Details',
      dsar_email_title: 'Datenschutzanfrage',
      dsar_email_sep: '---------------------',
    },
  },

  es: {
    header: {
      tagline: 'Especializados en crear interfaces, sitios web y aplicaciones.',
    },
    hero: {
      headline1: 'Soluciones digitales para',
      headline2: 'el comercio moderno',
      subheadline:
        'Diseñamos soluciones de software simples, claras y efectivas. Desde la creación de sitios web hasta aplicaciones móviles y promoción.',
      cta_start: 'Iniciar un proyecto',
      cta_services: 'Nuestros servicios',
    },
    services: {
      heading: 'Nuestra experiencia',
      subheading:
        'Nos enfocamos en tres áreas principales para ayudar a su negocio a prosperar en el espacio digital.',
      items: [
        {
          title: 'Creación y diseño de sitios web',
          description:
            'Sitios web personalizados y responsivos diseñados para convertir. Creamos interfaces claras que sus clientes adorarán.',
        },
        {
          title: 'Promoción digital',
          description:
            'Optimización estratégica de motores de búsqueda (SEO) y marketing en redes sociales para aumentar la visibilidad de su marca.',
        },
        {
          title: 'Desarrollo de aplicaciones móviles',
          description:
            'Aplicaciones móviles nativas y multiplataforma específicamente diseñadas para negocios minoristas para mejorar la lealtad del cliente.',
        },
      ],
    },
    contact: {
      heading: 'Iniciar un proyecto',
      subheading:
        'Cuéntenos brevemente sobre los objetivos de su proyecto y le responderemos con los próximos pasos.',
      name_label: 'Nombre completo',
      name_placeholder: 'Juan García',
      email_label: 'Correo electrónico',
      email_placeholder: 'you@example.com',
      message_label: 'Mensaje',
      message_placeholder: 'Describe el alcance del proyecto, plazos, idea aproximada del presupuesto.',
      send_btn: 'Enviar consulta',
      copy_btn: 'Copiar texto del correo',
      copied: '¡Copiado!',
      preview_label: 'Cuerpo del correo generado',
      chars_hint: 'caracteres',
      mail_if_not_open: 'Si su cliente de correo no se abrió, copie y envíe manualmente.',
      min_error: (min) => `La longitud mínima del mensaje es ${min} caracteres.`,
      max_error: (max) => `La longitud máxima del mensaje es ${max} caracteres.`,
      email_subject: (name) => `Consulta de proyecto de ${name}`,
      email_body_title: 'Solicitud de contacto',
      email_body_sep: '---------------',
      email_name: 'Nombre',
      email_message: 'Mensaje',
    },
    footer: {
      tagline:
        'Creamos soluciones digitales simples y efectivas para negocios minoristas en todo el mundo.',
      contact: 'Contacto',
      links: 'Enlaces',
      link_services: 'Servicios',
      link_about: 'Sobre nosotros',
      link_contact: 'Contacto',
      link_privacy: 'Política de privacidad',
      rights: 'Todos los derechos reservados.',
    },
    privacy: {
      badge: 'Política de privacidad',
      title: 'Política de privacidad',
      updated: 'Última actualización: 19 de noviembre de 2025',
      intro:
        'En <strong>shopprograms.com</strong> ("nosotros", "nos", "nuestro"), respetamos su privacidad y estamos comprometidos a protegerla mediante el cumplimiento de esta política.',
      collect_title: 'Información que recopilamos',
      collect_items: [
        '<strong>Información de contacto</strong> (por ejemplo, nombre, correo electrónico, teléfono) cuando nos contacta.',
        '<strong>Datos de uso</strong> como páginas vistas, enlaces clicados e información general del dispositivo recopilada a través de cookies/análisis.',
        '<strong>Comunicaciones</strong> que nos envía (solicitudes de soporte, detalles del proyecto).',
      ],
      use_title: 'Cómo usamos la información',
      use_items: [
        'Proporcionar y mejorar los servicios y la experiencia general.',
        'Responder a consultas y solicitudes de soporte.',
        'Analizar el rendimiento y prevenir el abuso.',
        'Cumplir con las obligaciones legales.',
      ],
      cookies_title: 'Cookies y analítica',
      cookies_text:
        'Podemos usar cookies y tecnologías similares. Puede controlar las cookies en la configuración de su navegador. Bloquear algunas cookies puede afectar la funcionalidad.',
      cookie_policy_title: 'Política de cookies',
      cookie_policy_items: [
        '<strong>Estrictamente necesarias</strong>: seguridad, equilibrio de carga.',
        '<strong>Preferencias</strong>: recordar elecciones.',
        '<strong>Analítica</strong>: comprender el uso.',
        '<strong>Marketing</strong>: medir campañas (si se usa).',
      ],
      cookie_policy_text:
        'Puede eliminar o bloquear cookies; algunas funciones pueden degradarse si se deshabilitan.',
      legal_title: 'Bases legales (EEE/Reino Unido)',
      legal_items: [
        '<strong>Contrato</strong>',
        '<strong>Intereses legítimos</strong>',
        '<strong>Consentimiento</strong>',
        '<strong>Obligación legal</strong>',
      ],
      sharing_title: 'Compartir y retención',
      sharing_text:
        'No vendemos datos personales. Los datos se retienen solo el tiempo necesario y luego se eliminan o anonimizan.',
      security_title: 'Seguridad',
      security_text:
        'Utilizamos medidas técnicas y organizativas razonables; ningún método es 100% seguro.',
      rights_title: 'Sus derechos',
      rights_text:
        'Según su ubicación, puede acceder, corregir, eliminar, restringir, objetar o solicitar portabilidad. Use el formulario a continuación.',
      dsar_title: 'Formulario de solicitud de datos (DSAR)',
      req_type_label: 'Tipo de solicitud',
      req_types: [
        { value: 'Access', label: 'Acceso (copia de datos)' },
        { value: 'Deletion', label: 'Eliminación' },
        { value: 'Correction', label: 'Corrección' },
        { value: 'Portability', label: 'Portabilidad' },
        { value: 'Opt-out', label: 'Cancelar suscripción de marketing' },
      ],
      name_label: 'Nombre completo',
      email_label: 'Correo electrónico',
      region_label: 'País / Región (opcional)',
      details_label: 'Detalles',
      details_placeholder: 'Describa su solicitud y cualquier identificador relevante.',
      confirm_text: 'Entiendo que puede ser necesaria la verificación de identidad.',
      submit_btn: 'Enviar solicitud',
      copy_btn: 'Copiar texto del correo',
      copied: '¡Copiado!',
      preview_label: 'Cuerpo del correo generado',
      preview_note: 'Envíe el correo generado si su cliente no se abrió automáticamente.',
      transfers_title: 'Transferencias internacionales',
      transfers_text: 'Los datos pueden procesarse en otros países con las salvaguardas aplicadas.',
      children_title: 'Privacidad infantil',
      children_text: 'No está dirigido a menores de 13 años; no recopilamos dicho datos conscientemente.',
      changes_title: 'Cambios',
      changes_text: 'Podemos actualizar la política; los cambios aparecerán aquí.',
      contact_title: 'Contáctenos',
      back_home: '← Volver al inicio',
      dsar_email_type: 'Tipo',
      dsar_email_name: 'Nombre',
      dsar_email_region: 'Región',
      dsar_email_details: 'Detalles',
      dsar_email_title: 'Solicitud del interesado',
      dsar_email_sep: '---------------------',
    },
  },

  fr: {
    header: {
      tagline: 'Spécialisés dans la création d\'interfaces, sites web & applications.',
    },
    hero: {
      headline1: 'Solutions numériques pour',
      headline2: 'le commerce moderne',
      subheadline:
        'Nous concevons des solutions logicielles simples, claires et efficaces. De la création de sites web aux applications mobiles et à la promotion.',
      cta_start: 'Démarrer un projet',
      cta_services: 'Nos services',
    },
    services: {
      heading: 'Notre expertise',
      subheading:
        'Nous nous concentrons sur trois domaines clés pour aider votre entreprise à prospérer dans l\'espace numérique.',
      items: [
        {
          title: 'Création & design de sites web',
          description:
            'Des sites web personnalisés et responsifs conçus pour convertir. Nous créons des interfaces claires que vos clients adoreront.',
        },
        {
          title: 'Promotion numérique',
          description:
            'Optimisation stratégique des moteurs de recherche (SEO) et marketing sur les réseaux sociaux pour accroître la visibilité de votre marque.',
        },
        {
          title: 'Développement d\'applications mobiles',
          description:
            'Applications mobiles natives et multiplateformes spécialement conçues pour les commerces de détail afin de renforcer la fidélité des clients.',
        },
      ],
    },
    contact: {
      heading: 'Démarrer un projet',
      subheading:
        'Parlez-nous brièvement de vos objectifs de projet et nous vous répondrons avec les prochaines étapes.',
      name_label: 'Nom complet',
      name_placeholder: 'Jean Dupont',
      email_label: 'E-mail',
      email_placeholder: 'you@example.com',
      message_label: 'Message',
      message_placeholder: 'Décrivez la portée du projet, les délais, l\'idée approximative du budget.',
      send_btn: 'Envoyer la demande',
      copy_btn: 'Copier le texte de l\'e-mail',
      copied: 'Copié !',
      preview_label: 'Corps de l\'e-mail généré',
      chars_hint: 'caractères',
      mail_if_not_open: 'Si votre client de messagerie ne s\'est pas ouvert, copiez et envoyez manuellement.',
      min_error: (min) => `La longueur minimale du message est de ${min} caractères.`,
      max_error: (max) => `La longueur maximale du message est de ${max} caractères.`,
      email_subject: (name) => `Demande de projet de ${name}`,
      email_body_title: 'Demande de contact',
      email_body_sep: '---------------',
      email_name: 'Nom',
      email_message: 'Message',
    },
    footer: {
      tagline:
        'Nous créons des solutions numériques simples et efficaces pour les commerces de détail dans le monde entier.',
      contact: 'Contact',
      links: 'Liens',
      link_services: 'Services',
      link_about: 'À propos',
      link_contact: 'Contact',
      link_privacy: 'Politique de confidentialité',
      rights: 'Tous droits réservés.',
    },
    privacy: {
      badge: 'Politique de confidentialité',
      title: 'Politique de confidentialité',
      updated: 'Dernière mise à jour : 19 novembre 2025',
      intro:
        'Chez <strong>shopprograms.com</strong> (« nous », « notre »), nous respectons votre vie privée et nous engageons à la protéger conformément à cette politique.',
      collect_title: 'Informations que nous collectons',
      collect_items: [
        '<strong>Informations de contact</strong> (par ex., nom, e-mail, téléphone) lorsque vous nous contactez.',
        '<strong>Données d\'utilisation</strong> telles que les pages vues, les liens cliqués et les informations générales sur l\'appareil collectées via des cookies/analyses.',
        '<strong>Communications</strong> que vous nous envoyez (demandes d\'assistance, détails du projet).',
      ],
      use_title: 'Comment nous utilisons les informations',
      use_items: [
        'Fournir et améliorer les services et l\'expérience globale.',
        'Répondre aux demandes de renseignements et d\'assistance.',
        'Analyser les performances et prévenir les abus.',
        'Respecter les obligations légales.',
      ],
      cookies_title: 'Cookies & Analyse',
      cookies_text:
        'Nous pouvons utiliser des cookies et des technologies similaires. Vous pouvez contrôler les cookies dans les paramètres de votre navigateur. Bloquer certains cookies peut affecter les fonctionnalités.',
      cookie_policy_title: 'Politique des cookies',
      cookie_policy_items: [
        '<strong>Strictement nécessaires</strong> : sécurité, équilibrage de charge.',
        '<strong>Préférences</strong> : mémorisation des choix.',
        '<strong>Analyse</strong> : compréhension de l\'utilisation.',
        '<strong>Marketing</strong> : mesure des campagnes (si utilisé).',
      ],
      cookie_policy_text:
        'Vous pouvez supprimer ou bloquer les cookies ; certaines fonctionnalités peuvent se dégrader si elles sont désactivées.',
      legal_title: 'Bases légales (EEE/Royaume-Uni)',
      legal_items: [
        '<strong>Contrat</strong>',
        '<strong>Intérêts légitimes</strong>',
        '<strong>Consentement</strong>',
        '<strong>Obligation légale</strong>',
      ],
      sharing_title: 'Partage & Rétention',
      sharing_text:
        'Nous ne vendons pas de données personnelles. Les données sont conservées uniquement le temps nécessaire, puis supprimées ou anonymisées.',
      security_title: 'Sécurité',
      security_text:
        'Nous utilisons des mesures techniques et organisationnelles raisonnables ; aucune méthode n\'est sûre à 100 %.',
      rights_title: 'Vos droits',
      rights_text:
        'Selon votre localisation, vous pouvez accéder, corriger, supprimer, restreindre, vous opposer ou demander la portabilité. Utilisez le formulaire ci-dessous.',
      dsar_title: 'Formulaire de demande de données (DSAR)',
      req_type_label: 'Type de demande',
      req_types: [
        { value: 'Access', label: 'Accès (copie des données)' },
        { value: 'Deletion', label: 'Suppression' },
        { value: 'Correction', label: 'Correction' },
        { value: 'Portability', label: 'Portabilité' },
        { value: 'Opt-out', label: 'Désabonnement marketing' },
      ],
      name_label: 'Nom complet',
      email_label: 'E-mail',
      region_label: 'Pays / Région (facultatif)',
      details_label: 'Détails',
      details_placeholder: 'Décrivez votre demande et les identifiants pertinents.',
      confirm_text: 'Je comprends qu\'une vérification d\'identité peut être requise.',
      submit_btn: 'Soumettre la demande',
      copy_btn: 'Copier le texte de l\'e-mail',
      copied: 'Copié !',
      preview_label: 'Corps de l\'e-mail généré',
      preview_note: 'Envoyez l\'e-mail généré si votre client ne s\'est pas ouvert automatiquement.',
      transfers_title: 'Transferts internationaux',
      transfers_text: 'Les données peuvent être traitées dans d\'autres pays avec des garanties appliquées.',
      children_title: 'Confidentialité des enfants',
      children_text: 'Non destiné aux enfants de moins de 13 ans ; nous ne collectons pas sciemment de telles données.',
      changes_title: 'Modifications',
      changes_text: 'Nous pouvons mettre à jour la politique ; les modifications apparaîtront ici.',
      contact_title: 'Contactez-nous',
      back_home: '← Retour à l\'accueil',
      dsar_email_type: 'Type',
      dsar_email_name: 'Nom',
      dsar_email_region: 'Région',
      dsar_email_details: 'Détails',
      dsar_email_title: 'Demande de la personne concernée',
      dsar_email_sep: '---------------------',
    },
  },
};

export default translations;
